import { apiCRMGasOrder as http } from '../http';

class ServiceCRUD {
  constructor(path) {
    this.path = path;
  }

  getAll() {
    return http.get(`${this.path}/`);
  }

  getAllSearch(showDisabled, size, page, querySearch) {
    return http.get(`${this.path}/?disabled=${showDisabled}`, {
      headers: {
        limit: size,
        offset: size * (page - 1)
      },
      params: {
        nome: querySearch
      }
    });
  }

  getAllFormSearch(size, page, querySearch) {
    return http.get(`${this.path}/`, {
      headers: {
        limit: size,
        offset: size * (page - 1)
      },
      params: {
        ...querySearch
      }
    });
  }

  getDailyStock(filialId, data) {
    return http.get(`${this.path}?filialId=${filialId}&data=${data}`);
  }

  getStockPerHour(filialId, data, hora) {
    return http.get(`${this.path}`, {
      params: {
        filialId: filialId,
        data: data,
        hora: hora
      }
    });
  }

  get(id) {
    return http.get(`${this.path}/${id}`);
  }

  getAccountByDocument(id) {
    return http.get(`${this.path}?documento=${id}`);
  }

  getBranchById(id) {
    return http.get(`${this.path}/filiais/${id}/produtos`);
  }

  delete(id) {
    return http.delete(`${this.path}/${id}`);
  }
  put(id, data) {
    return http.put(`${this.path}/${id}`, data);
  }

  putReader(data) {
    return http.put(`${this.path}`, data);
  }

  patch(id, data) {
    return http.patch(`${this.path}/${id}`, data);
  }

  post(data) {
    return http.post(`${this.path}`, data);
  }

  getDownloads(queryParams = {}) {
    return http.get(`${this.path}`, {
      params: {
        ...queryParams
      },
      responseType: 'blob'
    });
  }

  getDownloadsCsvUrl(queryParams = {}) {
    const searchParams = new URLSearchParams();

    for (const [key, value] of Object.entries(queryParams)) {
      searchParams.append(key, value);
    }

    searchParams.append('jwt', localStorage.getItem('token'));

    const url =
      `${process.env.REACT_APP_CRM_NACIONAL_URL}${this.path}?` +
      searchParams.toString();

    return `${url}`;
  }

  getDownloadsXlsxUrl(queryParams = {}) {
    const searchParams = new URLSearchParams();

    for (const [key, value] of Object.entries(queryParams)) {
      searchParams.append(key, value);
    }

    searchParams.append('jwt', localStorage.getItem('token'));

    const url =
      `${process.env.REACT_APP_CRM_NACIONAL_URL}${this.path}?` +
      searchParams.toString();

    return `${url}`;
  }
}

export default ServiceCRUD;
